/* eslint-disable max-len */
import React from "react";

import SecureOperatorRoute from "@/v2/routes/SecureOperatorRoute/SecureOperatorRoute";

const OperatorDetail = React.lazy(() => import("@/v1/components/pages/OperatorDetail"));
const OperatorCasinoDetail = React.lazy(() => import("@/v1/components/pages/CasinoDetail"));
const OperatorCasinoJurisdictionDetail = React.lazy(() =>
  import("@/v1/components/pages/CasinoJurisdictionDetail"),
);
const OperatorEnvironmentDetail = React.lazy(() =>
  import("@/v1/components/pages/EnvironmentDetail"),
);
const OperatorUserDetail = React.lazy(() => import("@/v1/components/pages/UserDetail"));

const routes = [
  {
    path: "/",
    component: React.lazy(() => import("@/v1/components/pages/Home")),
    exact: true,
  },
  {
    path: "/integrators",
    component: React.lazy(() =>
      import("@/v2/components/pages/Integrations/Integrators/Integrators"),
    ),
    exact: true,
  },
  {
    path: "/integrators/:integratorsID",
    component: React.lazy(() => import("@/v1/components/pages/IntegratorDetail")),
    exact: true,
  },
  {
    path: "/integrators/:integratorID/setups/:setupID",
    component: React.lazy(() => import("@/v1/components/pages/IntegratorSetup")),
    exact: true,
  },
  {
    path: "/integrators/:integratorID/setups/:setupID/skins/:skinID",
    component: React.lazy(() =>
      import("@/v2/components/pages/Administration/SkinDetail/SkinDetail"),
    ),
    exact: true,
  },
  {
    path: "/integrators/:integratorID/templates/:templateID",
    component: React.lazy(() => import("@/v1/components/pages/ParameterTemplate")),
    exact: true,
  },
  {
    path: "/software",
    component: React.lazy(() => import("@/v2/components/pages/Integrations/Softwares/Softwares")),
    exact: true,
  },
  {
    path: "/software/:softwareID",
    component: React.lazy(() => import("@/v1/components/pages/SoftwareDetail")),
    exact: true,
  },
  {
    path: "/games",
    component: React.lazy(() => import("@/v2/components/pages/Games/Games")),
    exact: true,
  },
  {
    path: "/games/categories",
    component: React.lazy(() => import("@/v2/components/pages/GameCategories/GameCategories")),
    exact: true,
  },
  {
    path: "/games/:gamesID(\\d+)",
    component: React.lazy(() => import("@/v1/components/pages/GameDetail")),
    exact: true,
  },
  {
    path: "/games/categories/:gameCategoriesID",
    component: React.lazy(() => import("@/v1/components/pages/GameCategoryDetail")),
    exact: true,
  },
  {
    path: "/games/:gameID/configuration/:configurationID",
    component: React.lazy(() => import("@/v1/components/pages/GameConfiguration")),
    exact: true,
  },
  {
    path: "/operators",
    component: React.lazy(() => import("@/v2/components/pages/Clients/Operators/Operators")),
    exact: true,
  },
  {
    path: "/operators/:operatorsID",
    component: () => <SecureOperatorRoute component={OperatorDetail} />,
    exact: true,
  },
  {
    path: "/operators/:operatorsID/casinos/:casinoID",
    component: () => <SecureOperatorRoute component={OperatorCasinoDetail} />,
    exact: true,
  },
  {
    path: "/operators/:operatorsID/casinos/:casinoID/jurisdiction/:jurisdictionID",
    component: () => <SecureOperatorRoute component={OperatorCasinoJurisdictionDetail} />,
    exact: true,
  },
  {
    path: "/casinos",
    component: React.lazy(() => import("@/v2/components/pages/Casinos/Casinos")),
    exact: true,
  },
  {
    path: "/game-lab",
    component: React.lazy(() => import("@/v2/components/pages/Tools/GameLabV3")),
  },
  {
    path: "/environments",
    component: React.lazy(() => import("@/v1/components/pages/Environments")),
    exact: true,
  },
  {
    path: "/operators/:operatorsID/casinos/:casinoID/environments/:environmentID",
    component: () => <SecureOperatorRoute component={OperatorEnvironmentDetail} />,
    exact: true,
  },
  {
    path: "/global-collections",
    component: React.lazy(() =>
      import("@/v2/components/pages/Administration/GlobalCollections/GlobalCollections"),
    ),
    exact: true,
  },
  {
    path: "/global-collections/:attributeCollectionID",
    component: React.lazy(() => import("@/v1/components/pages/GlobalCollectionDetail")),
    exact: true,
  },
  {
    path: "/markets",
    component: React.lazy(() => import("@/v2/components/pages/Administration/Markets/Markets")),
    exact: true,
  },
  {
    path: "/casino-collection-executions",
    component: React.lazy(() => import("@/v1/components/pages/CasinoCollectionExecutions")),
    exact: true,
  },
  {
    path: "/jurisdictions",
    component: React.lazy(() =>
      import("@/v2/components/pages/Administration/Jurisdictions/Jurisdictions"),
    ),
    exact: true,
  },
  {
    path: "/jurisdictions/:jurisdictionsID",
    component: React.lazy(() => import("@/v1/components/pages/JurisdictionDetail")),
    exact: true,
  },
  {
    path: "/countries",
    component: React.lazy(() => import("@/v2/components/pages/Countries/Countries")),
    exact: true,
  },
  {
    path: "/countries/:countriesID",
    component: React.lazy(() => import("@/v1/components/pages/CountryDetail")),
    exact: true,
  },
  {
    path: "/currencies",
    component: React.lazy(() => import("@/v1/components/pages/Currencies")),
    exact: true,
  },
  {
    path: "/languages",
    component: React.lazy(() => import("@/v2/components/pages/Administration/Languages/Languages")),
    exact: true,
  },
  {
    path: "/bonus-report",
    component: React.lazy(() => import("@/v2/components/pages/Invoicing/BonusReport/BonusReport")),
    exact: true,
    permissions: "INVOICING_READ",
  },
  {
    path: "/invoicing-report",
    component: React.lazy(() =>
      import("@/v2/components/pages/Invoicing/InvoicingReport/InvoicingReport"),
    ),
    exact: true,
    permissions: "INVOICING_READ",
  },
  {
    path: "/transaction-report",
    component: React.lazy(() =>
      import("@/v2/components/pages/Invoicing/TransactionReport/TransactionReport"),
    ),
    exact: true,
    permissions: "INVOICING_READ",
  },
  {
    path: "/smart-transaction-report",
    component: React.lazy(() =>
      import("@/v2/components/pages/Invoicing/SmartTransactionReport/SmartTransactionReport"),
    ),
    exact: true,
    permissions: "INVOICING_READ",
  },
  {
    path: "/operators/:operatorsID/users/:usersID",
    component: () => <SecureOperatorRoute component={OperatorUserDetail} />,
    exact: true,
  },
  {
    path: "/game-gallery",
    component: React.lazy(() => import("@/v1/components/pages/GameGallery")),
    exact: true,
  },
  {
    path: "/forced-response-policies/:playerId/:currencyId",
    component: React.lazy(() =>
      import("@/v2/components/pages/ForcedResponsePolicies/ForcedResponsePolicies"),
    ),
    exact: true,
  },
  {
    path: "/dashboards",
    component: React.lazy(() =>
      import("@/v2/components/pages/BusinessIntelligence/Dashboards/Dashboards"),
    ),
    exact: true,
  },
  {
    path: "/dashboards/:dashboardId",
    component: React.lazy(() =>
      import("@/v2/components/pages/BusinessIntelligence/DashboardDetail/DashboardDetail"),
    ),
    exact: true,
  },
  {
    path: "/team-members",
    component: React.lazy(() =>
      import("@/v2/components/pages/Administration/TeamMembers/TeamMembers"),
    ),
    exact: true,
    adminRestricted: true,
  },
  {
    path: "/my-tasks",
    component: React.lazy(() => import("@/v2/components/pages/Tasks/MyTasks/MyTasks")),
    exact: true,
  },
  {
    path: "/testing-client",
    component: React.lazy(() =>
      import("@/v2/components/pages/Tools/ClientTestTool/ClientTestTool"),
    ),
    exact: true,
  },
  {
    path: "/sales-matrix",
    component: React.lazy(() => import("@/v2/components/pages/Tools/SalesMatrix/SalesMatrix")),
    exact: true,
  },
  {
    path: "/roles-and-permissions",
    component: React.lazy(() =>
      import("@/v2/components/pages/Administration/RolesPermissions/RolesPermissions"),
    ),
    exact: true,
    adminRestricted: true,
  },
  {
    path: "/roles-and-permissions/:id",
    component: React.lazy(() =>
      import("@/v2/components/pages/Administration/RolePermissionDetail/RolePermissionDetail"),
    ),
    exact: true,
    adminRestricted: true,
  },
  {
    path: "/uuid-generator",
    component: React.lazy(() => import("@/v2/components/pages/Tools/UUIDGenerator/UUIDGenerator")),
    exact: true,
  },
  {
    path: "/tables",
    component: React.lazy(() => import("@/v2/components/pages/Tables/Tables")),
    exact: true,
  },
  {
    path: "/games-test-tool",
    component: React.lazy(() => import("@/v2/components/pages/Tools/GamesTestTool/GamesTestTool")),
    exact: true,
  },
  {
    path: "/tasks",
    component: React.lazy(() => import("@/v2/components/pages/AleaTeamTasks/AleaTeamTasks")),
    exact: true,
  },
  {
    path: "/trace-id-check",
    component: React.lazy(() => import("@/v2/components/pages/TraceIdCheck/TraceIdCheck")),
    exact: true,
  },
  {
    path: "/session-check",
    component: React.lazy(() => import("@/v2/components/pages/SessionCheck/SessionCheck")),
    exact: true,
  },
  {
    path: "/session-check/:aleaSessionId",
    component: React.lazy(() => import("@/v2/components/pages/SessionDetails/SessionDetails")),
    exact: true,
  },
  {
    path: "/session-check/:aleaSessionId/action/:actionId",
    component: React.lazy(() => import("@/v2/components/pages/ActionDetails/ActionDetails")),
    exact: true,
  },
  {
    path: "/round-visuals",
    component: React.lazy(() => import("@/v2/components/pages/RoundVisual/RoundVisual")),
    exact: true,
  },
  {
    path: "/round-check",
    component: React.lazy(() => import("@/v2/components/pages/RoundCheck/RoundCheck")),
    exact: true,
  },
  {
    path: "/round-check/:aleaRoundId",
    component: React.lazy(() => import("@/v2/components/pages/RoundDetails/RoundDetails")),
    exact: true,
  },
  {
    path: "/round-check/:aleaRoundId/action/:actionId",
    component: React.lazy(() => import("@/v2/components/pages/ActionDetails/ActionDetails")),
    exact: true,
  },
  {
    path: "/player-check",
    component: React.lazy(() => import("@/v2/components/pages/PlayerCheck/PlayerCheck")),
    exact: true,
  },
  {
    path: "/player-check/:playerAccountId",
    component: React.lazy(() =>
      import("@/v2/components/pages/PlayerCheckDetails/PlayerCheckDetails"),
    ),
    exact: true,
  },
  {
    path: "/markets/:marketId",
    component: React.lazy(() => import("@/v2/components/pages/MarketDetail/MarketDetail")),
    exact: true,
  },
];

export default routes;
